// export default () => {
//     const rolePermissions = JSON.parse(localStorage.getItem("user"))
//     .roles.map((role) => role.permissions)
//     .flat();

//   const filteredPermissions = [
//     ...new Set(
//       rolePermissions.map((permission) => permission.id)
//     )
//   ].map((id) =>
//       rolePermissions.find((permission) => permission.id === id)
//     );
//     return filteredPermissions
// }

export default () => {
    const userDataString = localStorage.getItem("user");
    
    // Return empty array if user data doesn't exist
    if (!userDataString) {
        return [];
    }
    
    const userData = JSON.parse(userDataString);
    
    // Return empty array if user data is invalid or has no roles
    if (!userData || !userData.roles || !Array.isArray(userData.roles)) {
        return [];
    }
    
    const rolePermissions = userData.roles
        .map((role) => role.permissions)
        .flat();

    const filteredPermissions = [
        ...new Set(
            rolePermissions.map((permission) => permission.id)
        )
    ].map((id) =>
        rolePermissions.find((permission) => permission.id === id)
    );
    
    return filteredPermissions;
}